import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  activatedRoute = inject(ActivatedRoute);
  _title = inject(Title);
  configService = inject(ConfigService);
  
  constructor() { }

  public updateTitle(title?: string): void {
    const storeName = this.configService.configState().store?.name;
    const storeCity = this.configService.configState().store?.city;
    const storeState = this.configService.configState().store?.state;

    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    setTimeout(() => {
      if (storeName && storeCity && storeState) {
        this.setUpdatedTitle(title ?? route.snapshot.title ?? '', storeName, storeCity, storeState);
      }
    })
  }

  private setUpdatedTitle(title: string, storeName: string, storeCity: string, state: string): void {
    if(title.length) {
      const updatedTitle = `${title} | ${storeName} at ${storeCity}, ${state}`;
      this._title.setTitle(updatedTitle);
    }
  }
}